module.exports = __webpack_public_path__ + "img/Nav_decline.60fba135.svg";